export default __webpack_public_path__ + "static/media/circle.422a6b82.png";